import styled from "styled-components";

export const BreadcrumbContainer = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.tokens.color.background.primary};
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
`;

export const BreadcrumbHeader = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 1rem 2rem 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
`;

export const BreadcrumbNav = styled.nav`
  display: flex;
  align-items: center;
  gap: 0.125rem;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
`;

export const BreadcrumbItem = styled.div`
  display: flex;
  align-items: center;
`;

export const BreadcrumbLink = styled.button`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: none;
  border: none;
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  cursor: pointer;
  color: ${({ theme }) => theme.tokens.color.text.secondary};
  transition: all 0.2s ease;
  font-family: inherit;
  font-size: 0.875rem;
  
  &:hover {
    background: ${({ theme }) => theme.tokens.color.background.secondary};
    color: ${({ theme }) => theme.tokens.color.text.primary};
  }
  
  &:focus {
    outline: 2px solid ${({ theme }) => theme.tokens.color.border.focusStandard};
    outline-offset: 2px;
  }
`;

export const BreadcrumbCurrent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.125rem 0.25rem;
  color: ${({ theme }) => theme.tokens.color.text.primary};
  font-size: 0.875rem;
`;

export const BreadcrumbCurrentLabel = styled.span`
  font-weight: 500;
`;

export const BreadcrumbSeparator = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0.0625rem;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.tokens.color.text.tertiary};
  user-select: none;
`;

export const TitleSection = styled.div`
  margin-top: 0;
  
  h1 {
    margin: 0;
    padding: 0;
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.2;
    color: ${({ theme }) => theme.tokens.color.text.primary};
    font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  }
`;

export const DescriptionSection = styled.div`
  margin-top: 0.25rem;
  
  p {
    margin: 0;
    padding: 0;
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.4;
    color: ${({ theme }) => theme.tokens.color.text.primary};
    opacity: 0.8;
    font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  }
`;
